import React from 'react';
import loadable from '@loadable/component';
import { Loading } from 'components';
import { FormattedMessage } from 'react-intl';

// Constants
import {
	ROUTES_PATH_ADMIN,
	ROUTES_PATH_ADMIN_PLAYER_UNIVERSE,
	ROUTES_PATH_ADMIN_REPORTING,
	ROUTES_PATH_ADMIN_TAGS,
	ROUTES_PATH_EDIT_DOMAIN_SETTINGS,
} from 'routes';

// Icons
import {
	Tv as ScreenIcon,
	AdminPanelSettings as AdminIcon,
	Settings as SettingIcon,
	Analytics as ReportingIcon,
	LocalOffer as TagIcon,
} from '@mui/icons-material';

// components
const PlayerUniverse = loadable(() => import('./components/PlayerUniverse/PlayerUniverse'), {
	fallback: <Loading size={50} />,
});
const EditDomainSettingsList = loadable(
	() =>
		import(
			'./components/EditDomainSettings/components/EditDomainSettingsList/EditDomainSettingsList'
		),
	{
		fallback: <Loading size={50} />,
	}
);
const AdminHome = loadable(() => import('./components/AdminHome/AdminHome'), {
	fallback: <Loading size={50} />,
});
const Reporting = loadable(() => import('./components/Reporting/ReportingHome'), {
	fallback: <Loading size={50} />,
});
const TagsList = loadable(() => import('./components/Tags/components/TagsList/TagsList'), {
	fallback: <Loading size={50} />,
});

export const AdminRoutes = [
	{
		path: ROUTES_PATH_ADMIN, // unique key in routes
		sidebarName: <FormattedMessage id="pages.Admin.Routes.Admin" />,
		sidebarIcon: AdminIcon,
		component: AdminHome,
		noBreadcrumbs: true,
		requiredUserLevel: { $gte: 40 },
		children: [
			{
				path: ROUTES_PATH_ADMIN_PLAYER_UNIVERSE,
				sidebarName: <FormattedMessage id="pages.Admin.Routes.PlayerUniverse" />, //'PlayerUniverse',
				sidebarIcon: ScreenIcon,
				noBreadcrumbs: true,
				component: PlayerUniverse,
				requiredUserLevel: { $gte: 60 },
			},
			{
				path: ROUTES_PATH_ADMIN_REPORTING,
				sidebarName: <FormattedMessage id="pages.Admin.Routes.Reporting" />,
				sidebarIcon: ReportingIcon,
				noBreadcrumbs: true,
				component: Reporting,
				requiredUserLevel: { $gte: 40 },
			},
			{
				path: ROUTES_PATH_EDIT_DOMAIN_SETTINGS,
				sidebarName: <FormattedMessage id="pages.EditDomainSettings.Routes.EditDomainSettings" />,
				sidebarIcon: SettingIcon,
				component: EditDomainSettingsList,
				noBreadcrumbs: false,
				requiredUserLevel: { $gte: 60 },
			},
			{
				path: ROUTES_PATH_ADMIN_TAGS,
				sidebarName: <FormattedMessage id="pages.Admin.Routes.Tags" />,
				sidebarIcon: TagIcon,
				component: TagsList,
				noBreadcrumbs: false,
				requiredUserLevel: { $gte: 40 },
			},
		],
	},
];

let adminRoutesByPath = {};
const setRoutesByPath = (routes = []) => {
	routes.forEach((route) => {
		adminRoutesByPath[route.path] = route;
		if (route.children && route.children.length > 0) {
			setRoutesByPath(route.children);
		}
	});
};
setRoutesByPath(AdminRoutes);

export { adminRoutesByPath };

export default AdminRoutes;
